export const LEAD_FORM_CONVERSION_EVENT_NAME = 'lead_form_submitted';
